module.exports = __webpack_public_path__ + "5405db36b80d7909a24b5d545b9b08ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/menu_icons/Tickers.png
// module id = 816
// module chunks = 0